var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{staticClass:"my-2 mx-1 search-input",attrs:{"label":"Search","single-line":"","prepend-inner-icon":"fa-search","hint":_vm.hint},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})}
var staticRenderFns = []

export { render, staticRenderFns }